import { NotificationRibbonParams } from '~/components/contentful/notification-ribbon'
import { SortOptionType, SortOrder } from '~/app/common/enums'

export enum SearchTypes {
  Products = 'products',
  Retailers = 'retailers',
}

export const getSearchDropdownOptions = (t: Function) => {
  return [
    {
      key: SearchTypes.Products,
      value: t('search.types.products'),
    },
    {
      key: SearchTypes.Retailers,
      value: t('search.types.retailers'),
    },
  ]
}

export const SEARCH_QUERY_MIN_LENGTH = 3

export const RETAILERS_SEARCH_QUERY_MIN_LENGTH = 1

export const RETAILERS_SORT_OPTIONS = [
  {
    name: SortOptionType.EarnRate,
    order: SortOrder.Ascending,
    messageName: 'earnRateLowToHigh',
  },
  {
    name: SortOptionType.EarnRate,
    order: SortOrder.Descending,
    messageName: 'earnRateHighToLow',
  },
  {
    name: SortOptionType.Name,
    order: SortOrder.Ascending,
    messageName: 'nameAscending',
  },
  {
    name: SortOptionType.Name,
    order: SortOrder.Descending,
    messageName: 'nameDescending',
  },
]

export const sortNotificationRibbonsByOrder = (
  ribbons: NotificationRibbonParams[],
) => {
  const orderedRibbons = ribbons?.filter(
    (ribbon) => typeof ribbon?.order == 'number',
  )
  const unOrderedRibbons = ribbons?.filter(
    (ribbon) => typeof ribbon?.order == 'undefined',
  )

  const sortedRibbons = orderedRibbons?.sort(
    (a, b) => Number(a.order) - Number(b.order),
  )

  return [...sortedRibbons, ...unOrderedRibbons]
}
